import { FC } from 'react';

import logo from 'assets/images/logo.svg';

import styles from './index.module.scss';

export const LogoType: FC = () => {
	return (
		<div className={styles.logo}>
			<img src={logo} alt="crowd pear" />
		</div>
	);
};
